import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { Button } from '@uhg-abyss/web/ui/Button';

const StyledDiv = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  padding: '$sm  $md',
  '@media (min-width: 984px)': {
    padding: '$md',
  },
});

const AccountNumberTitleContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: '$gray8',
  fontWeight: '700',
  fontSize: '18px',
});

const AccountNumberValueContainer = styled('div', {
  color: '$gray7',
  fontWeight: '500',
  fontSize: '18px',
});

const StyledTooltip = styled(Tooltip, {
  display: 'flex',
  alignItems: 'center',
});

const HorizontalRule = styled('div', {
  margin: '$sm 0',
  height: 0,
  width: '100%',
  borderTop: '1px solid $gray3',
  marginTop: '16px !important',
  marginBottom: '-10px !important',
});

const StyledButton = styled(Button, {
  '&.abyss-tooltip-trigger': {
    width: 24,
    height: 24,
  },
});

export const AccountNumber = ({
  accountNumberValue,
  accountNumberApiError,
}) => {
  const { user } = useUser.state();
  const { getMessage } = usePPDLagoon();
  const accountNumberTitle = getMessage('account-number-title');
  const accountNumberError = getMessage('account-number-error');
  return (
    <StyledDiv>
      <AccountNumberTitleContainer>
        {accountNumberTitle}
        <StyledTooltip
          content='This is your unique 10-digit account number that will be used for identification.'
          position='right'
        >
          <StyledButton
            rounded
            variant='ghost'
            data-testid='account-number-info-button-tooltip-trigger'
          >
            <IconSymbol
              icon='info'
              size={24}
              variant='outlined'
              data-testid='account-number-info-icon'
            />
          </StyledButton>
        </StyledTooltip>
      </AccountNumberTitleContainer>
      <AccountNumberValueContainer>
        {user?.isUserApiError || accountNumberApiError
          ? accountNumberError
          : accountNumberValue}
      </AccountNumberValueContainer>
      <HorizontalRule />
    </StyledDiv>
  );
};

AccountNumber.propTypes = {
  accountNumberValue: PropTypes.string.isRequired,
};
